/**
 * Conteúdo mínimo por rota, até a feature real chegar (M1–M5).
 *
 * ⚠️ **Não é `<div />` vazio de propósito.** Uma rota sem `<h1>` quebra `page-has-heading-one` do
 * `axe-core` e deixa quem usa leitor de ecrã sem âncora para saber onde aterrou. O esqueleto desta
 * fatia tem de ser navegável de verdade — senão o gate C2 da T0.15 reprovaria o próprio esqueleto,
 * e com razão.
 */

import { useTranslation } from 'react-i18next';

export interface PlaceholderProps {
  /** Título da tela. Vem traduzido de quem monta a rota. */
  titulo: string;
  /** Identificador estável para os testes E2E. */
  testId?: string;
}

export function Placeholder({ titulo, testId }: PlaceholderProps) {
  const { t } = useTranslation();

  return (
    <section className="mx-auto w-full max-w-content px-4 py-8" data-testid={testId}>
      <h1 className="font-display text-[length:var(--d-2)] font-semibold text-ink-1">{titulo}</h1>
      <p className="mt-2 font-sans text-sm text-ink-3">{t('state.underConstruction')}</p>
    </section>
  );
}
